"use client";

import { useEffect } from "react";

/**
 * Sets dir="ltr" on the w3m-modal element
 * This is needed because the Web3Modal component doesn't support RTL properly
 */
export const W3MModalDirFix = () => {
  useEffect(() => {
    const fixModalDir = () => {
      const modal = document.querySelector("w3m-modal");
      if (modal) {
        modal.setAttribute("dir", "ltr");
        return true;
      }
      return false;
    };

    // Set immediately if element already exists
    if (fixModalDir()) return;

    // Watch for the element to be added to the DOM (direct children of body only)
    const observer = new MutationObserver(() => {
      if (fixModalDir()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: false,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
};
